<template>
  <div class="container-snackbars pb-5">
    <template
      v-for="(snackbarItem, index) in getErrorSnackbarItems"
      :key="snackbarItem.id"
    >
      <v-snackbar
        v-if="index < 3"
        :model-value="{ vuetifySucks: true }.vuetifySucks"
        snackn
        :color="snackbarItem.color"
        :data-cy="snackbarItem.error ? 'snackbar-error' : 'snackbar'"
        transition="slide-y-reverse-transition"
        :timeout="snackbarItem.timeout"
        :contained="true"
        :timer="snackbarItem.timeout ? false : 'white'"
        max-width="65vw"
      >
        <div class="snackbar-text">
          {{ snackbarItem.text }}
        </div>
        <template #actions>
          <v-btn
            class="text-none"
            variant="text"
            @click="clickActionBtn(snackbarItem)"
            >{{ snackbarItem.buttonText ?? 'Ok' }}</v-btn
          >
        </template>
      </v-snackbar>
    </template>
    <template
      v-for="(snackbarItem, index) in getSuccessSnackbarItems.slice().reverse()"
      :key="snackbarItem.id"
    >
      <v-snackbar
        v-if="index < 5"
        :model-value="{ vuetifySucks: true }.vuetifySucks"
        :color="snackbarItem.color"
        :data-cy="snackbarItem.error ? 'snackbar-error' : 'snackbar'"
        transition="slide-y-reverse-transition"
        :timeout="snackbarItem.timeout"
        :contained="true"
        timer="white"
        max-width="65vw"
      >
        <div class="snackbar-text">
          {{ snackbarItem.text }}
        </div>
        <template #actions>
          <v-btn
            class="text-none"
            variant="text"
            @click="clickActionBtn(snackbarItem)"
            >{{ snackbarItem.buttonText ?? 'Ok' }}</v-btn
          >
        </template>
      </v-snackbar>
    </template>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { SnackbarItem, snackbarStore } from '../../store/pinia/SnackbarStore';
import { mapActions, mapState } from 'pinia';

export default defineComponent({
  name: 'SnackbarContainer',
  computed: {
    ...mapState(snackbarStore, [
      'getErrorSnackbarItems',
      'getSuccessSnackbarItems'
    ])
  },
  methods: {
    ...mapActions(snackbarStore, ['removeSnackbarItem']),
    clickActionBtn(snackbarItem: SnackbarItem) {
      if (snackbarItem.buttonAction) {
        snackbarItem.buttonAction();
      }
      this.removeSnackbarItem(snackbarItem.id);
    }
  }
});
</script>

<style scoped lang="scss">
.container-snackbars {
  position: fixed;
  display: flex;
  flex-flow: column-reverse;
  justify-content: flex-start;
  width: 100%;
  height: 100%;
  pointer-events: none;
  margin: 0;
  z-index: 2000;

  // Overriding some vuetify snackbar styles for custom stacking of snackbars
  .v-snackbar {
    height: auto;
    position: relative;
    margin-top: 15px;
  }
  .snackbar-text {
    word-break: break-word;
  }
}
</style>
